import i18n from "i18next";
import { ChangeDateFormat } from "../../../Common/Helpers/ChangeDateFormat";

export const API_KEY_STATUS = {
    ACTIVE: 'Active',
    EXPIRED: 'Expired',
    REVOKED: 'Revoked',
};

export const apiKeyStatusLabel = (status) =>
    status === API_KEY_STATUS.ACTIVE ? i18n.t('apiKey.statusActive')
        : status === API_KEY_STATUS.EXPIRED ? i18n.t('apiKey.statusExpired')
            : status === API_KEY_STATUS.REVOKED ? i18n.t('apiKey.statusRevoked')
                : status || '';

class ResponseApiKey {
    constructor({
                    id = '',
                    visualId = '',
                    name = '',
                    prefix = '',
                    scope = '',
                    status = '',
                    expiresAt = null,
                    lastUsedAt = null,
                    revokedAt = null,
                    revokedByName = '',
                    createdAt = null,
                    createdByName = '',
                } = {}) {
        this.id = id;
        this.visualId = visualId;
        this.name = name;
        this.prefix = prefix;
        this.scope = scope;
        this.status = status;
        this.expiresAt = expiresAt;
        this.lastUsedAt = lastUsedAt;
        this.revokedAt = revokedAt;
        this.revokedByName = revokedByName;
        this.createdAt = createdAt;
        this.createdByName = createdByName;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const attributes = {
            id: {
                'label': 'Id',
                'sortable': true,
                'sortField': 'id',
                'value': (item) => item.id || "",
            },
            visualId: {
                'label': 'Id',
                'sortable': true,
                'sortField': 'visualId',
                'value': (item) => item.visualId || "",
            },
            name: {
                'label': i18n.t('apiKey.name'),
                'sortable': true,
                'sortField': 'name',
                'value': (item) => item.name || "",
            },
            prefix: {
                'label': i18n.t('apiKey.prefix'),
                'sortable': true,
                'sortField': 'prefix',
                'value': (item) => item.prefix ? `${item.prefix}…` : "",
            },
            status: {
                'label': i18n.t('modelLabel.status'),
                'sortable': true,
                'sortField': 'status',
                'insideClass': (item) => item.status === API_KEY_STATUS.ACTIVE
                    ? 'box-green me-4 reimbursement-status-pill-auto'
                    : item.status === API_KEY_STATUS.REVOKED
                        ? 'box-red me-4 reimbursement-status-pill-auto'
                        : 'box-custom-grey me-4 reimbursement-status-pill-auto',
                'value': (item) => apiKeyStatusLabel(item.status),
                'type': 'select',
            },
            expiresAt: {
                'label': i18n.t('apiKey.expiresAt'),
                'sortable': true,
                'sortField': 'expiresAt',
                'showInFilter': false,
                'value': (item) => item.expiresAt ? ChangeDateFormat('date', item.expiresAt) : i18n.t('apiKey.never'),
            },
            lastUsedAt: {
                'label': i18n.t('apiKey.lastUsedAt'),
                'sortable': true,
                'sortField': 'lastUsedAt',
                'showInFilter': false,
                'value': (item) => item.lastUsedAt ? ChangeDateFormat('dateTime', item.lastUsedAt) : i18n.t('apiKey.neverUsed'),
            },
            createdByName: {
                'label': i18n.t('apiKey.createdByName'),
                'sortable': true,
                'sortField': 'createdByName',
                'value': (item) => item.createdByName || "",
            },
            createdAt: {
                'label': i18n.t('modelLabel.createdAt'),
                'sortable': true,
                'sortField': 'createdAt',
                'showInFilter': false,
                'value': (item) => item.createdAt ? ChangeDateFormat('dateTime', item.createdAt) : '',
            },
        };

        return attributes;
    }
}

export default ResponseApiKey;
